<template>
    <div class="pmtdiv">
        <pencilbutton @click="Show()" v-if="showButton"/>
        <!-- <smallbutton :toplabel="name" @click="startAdd()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton :toplabel="name" @click="startAdd()" v-if="!showButton"/> -->
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    <label class="titlelabel">Select Options for {{productName}} </label>
                    <br/>

                    <div class="horizFlex wrap"> 
                        <div v-for="i in selectedOptions" :key="i.id" :value="i.id">
                            <smallbutton :buttonclass="getbuttonclass(i)"  :toplabel="getButtonText(i)" @click="select(i)"/>  
                        </div> 
                        
                    </div>
                                    
    
                    <smallbutton  @click="Save()" toplabel="Save" />
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                    
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodal from '../controls/actionmodal.vue'
        import pencilbutton from '../controls/pencilbutton.vue'
    export default {
        name:'productoptions',
        components:{
            smallbutton,
            actionmodal,
            linkbutton,
            pencilbutton
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },

            buttonClass:{
                type:String,
                default:'button buttonpay'
            },
            productName:{
                type:String,

            },
            options:{
                type:Array
            },
            lineItemId:{
                type:Number,
                default:0
            }
            
        },
        mixins:[format],
        data(){
            return{
                selectedOptions:[]
                
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait'
            ]),
            
        },
        methods:{
            getButtonText(item){
                var t = item.name
                if(item.price>0){
                    t = t + ' ' + this.$options.filters.toCurrency(item.price)
                }
                return t
            },
            Show(options){
                if(options==undefined){
                    this.selectedOptions= this.options
                }else{
                    this.selectedOptions=options
                }
                
                this.responseMessage=null
                this.$refs.mymodal.openModal()

            },
            getbuttonclass(item){
 
                    if(item.selected){
                        return " buttonprimary selectedoptionbuttonbig"
                    }else{
                        return " buttonprimary optionbuttonbig"
                    }
                
                
            },
            select(item){
                item.selected=!item.selected
            },
            Save(){
               
                this.$emit('save',this.selectedOptions,this.lineItemId)
                this.$refs.mymodal.closeModal()
            }
        }
    }
    </script>
    
    <style>
    .option{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoption{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    